angular.module('directives.dashboard').directive('wgtArticleNegativeBalance', ['DashboardApiService','$state',
    function (DashboardApiService, $state) {
        return {
            templateUrl: 'directives/dashboard/widgets/wgtArticleNegativeBalance/wgtArticleNegativeBalance.tpl.html',
            link: function ($scope) {
                $scope.isLoaded = false;
                $scope.hasError = false;

                $scope.loadWidget = function () {
                    DashboardApiService.getWidgetData($scope.item.name, $scope.item.setting)
                        .then(function (response) {
                            if (response.data === '') {
                                //No data, leaving
                                return;
                            }
                            $scope.widgetData = response.data;
                            $scope.isLoaded = true;
                        }, function (response) {
                            $scope.hasError = true;
                        });
                };

                $scope.gotoArticle = function(articleId)  {
                     $state.go('stock.articlesearch.article', { articleId: articleId });
                };
                $scope.loadWidget();
            }
        };
    }
]);
